import gql from 'graphql-tag';
import { LISTING_FRAGMENT } from './listing.fragment';
import { LOCATION_FRAGMENT } from './location.fragment';

export const LISTING_MAP_FRAGMENT = gql`
    ${LISTING_FRAGMENT}
    ${LOCATION_FRAGMENT}

    fragment LISTING_MAP_FRAGMENT on Listing {
        ...LISTING_FRAGMENT
        location {
            ...LOCATION_FRAGMENT
        }
    }
`;
